import { Box, Divider, Center, Container } from "@mantine/core";
import { useEffect, useState } from "react";
import Stages from "./Stages";
import AuthForm from "./AuthForm";
import Cookies from "js-cookie";

export default function Dashboard() {
  const [secretReady, setSecretReady] = useState(false);
  const [stages, setStages] = useState([]);
  const [stagesAdmin, setStagesAdmin] = useState([]);

  const { REACT_APP_API_URL } = process.env;

  useEffect(() => {
    const fetchToken = async (cookie: string) => {
      const targetURL = REACT_APP_API_URL + "token/valid";
      const response = await fetch(targetURL, {
        headers: { Authorization: "Bearer " + cookie },
      });
      return response;
    };

    const fetchStages = async (secret: string) => {
      const targetURL = REACT_APP_API_URL + "stages?admin=True";
      const response = await fetch(targetURL, {
        headers: { Authorization: "Bearer " + secret },
      });
      const stagesData = await response.json();
      setStages(stagesData.data.stages);
      setStagesAdmin(stagesData.data.admin);
    };

    const cookie = Cookies.get("access_token");

    if (typeof cookie !== "undefined") {
      (async () => {
        const response = await fetchToken(cookie);

        if (response.status !== 200) {
          Cookies.remove("access_token");
        } else {
          setSecretReady(true);
          await fetchStages(cookie);
        }
      })();
    }
  }, [secretReady, REACT_APP_API_URL]);

  if (!secretReady) {
    return <AuthForm setSecretReady={setSecretReady} />;
  }

  return (
    <Container fluid>
      <Stages regularStages={stages} adminStages={stagesAdmin} />
    </Container>
  );
}
